import {
    FeatureBuyTimesBetValue
} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";

export enum WIN_CAP_MODES {
    CAP_MODE_STANDARD = "CAP_MODE_STANDARD",
    CAP_MODE_10000 = "CAP_MODE_10000"
}

export enum SPECIAL_SYMBOL_NAMES {
    SM1 = "SM1",
    SM2 = "SM2",
    X_WAYS = "X_WAYS",
    X_NUDGE_WILD = "X_NUDGE_WILD",
    X = "X",
    XH = "XH",
    S = "S",
    S2 = "S2",
    W = "W",
    NW = "NW" // this is xNudge wild in eval area and nudge wild in reels in case of sticky xNudge
}

export enum KMD_SYMBOL_ANIMATIONS {
    NORMAL = "full",
    SPIN = "vertical_spin",
    NO_WIN = "fullNoWin",
    WIN = "fullWin",
    HALF_NO_WIN = "halfNoWin",
    HALF_WIN = "halfWin",
    HALF = "half",
    TOGGLE = "full_toggle",
    IGNITE_START = "start",
    IGNITE_START_HALF = "start_half",
    IGNITE_START_SEVENTY_FIVE = "start_seventyFive",
    IGNITE_LOOP = "loop",
    IGNITE_LOOP_HALF = "loop_half",
    IGNITE_LOOP_SEVENTY_FIVE = "loop_seventyFive",
    LAND = "landing",
    SEVENTY_FIVE = "seventyFive",
    SEVENTY_FIVE_NO_WIN = "seventyFiveNoWin",
    SEVENTY_FIVE_WIN = "seventyFiveWin"
}

export enum X_WAYS_ANIMATIONS {
    EXPAND_MID = "Expand_Anim",
    EXPAND_DOWN = "Expand_down",
    EXPAND_UP = "Expand_up",
    EXPAND_UP_4 = "Expand_up_1x4",
    REVEAL = "animation"
}

export enum X_NUDGE_ANIMATIONS {
    NO_WIN_HELPER = "_nowin",
    WIN_HELPER = "_win",
    UP_1_STEP = "up_1_step",
    UP_2_STEP = "up_2_step",
    UP_3_STEP = "up_3_step",
    UP_3_STEP_REVERSE = "up_3_step_nowin_reverse",
    FULL_WIN_2 = "fullWin_2",
    FULL_TOGGLE_2 = "full_toggle_2",
    FULL_WIN_3 = "fullWin_3",
    SM1_HELPER = "_ken",
    SM2_HELPER = "_barbie",
    FULL_200 = "full_200",
    HELPER_300 = "300" // this state is just a helper, doesn't exist in it's json
}

export enum MULTIPLIER_AND_WAYS_ANIMATIONS {
    HELPER = "_win",
    FS = "fs",
    MAIN = "main",
    SFS = "sfs"
}

export enum X_HOLE_ANIMATIONS {
    BLUR = "blur",
    ACTIVE = "win",
    SUCK = "suck",
    SUCK_OVERLAY = "animation",
    SUCK_CLOSE = "animation",
    BLAST = "level_",
    TO_WILD = "xhole_to_wild",
    ANTICIPATION = "anticipation"
}

export enum S1_S2_ANIMATIONS {
    SM1 = "toSpecialM1",
    SM2 = "toSpecialM2",
    X_NUDGE_WILD = "toXNudge",
    X_WAYS = "toXWays",
    W = "toWild",
    M1 = "toM1",
    M2 = "toM2"
}

export enum NORMAL_WIN_LEVEL_NAMES {
    TINY = "TINY",
    SMALL = "SMALL",
    MEDIUM = "MEDIUM",
    LARGE = "LARGE"
}

export enum BIG_WIN_LEVEL_NAMES {
    BIG_WIN_01 = "BIG_WIN_01",
    BIG_WIN_02 = "BIG_WIN_02",
    BIG_WIN_03 = "BIG_WIN_03",
    BIG_WIN_04 = "BIG_WIN_04",
    BIG_WIN_05 = "BIG_WIN_05",
    BIG_WIN_06 = "BIG_WIN_06"
}

export interface ISymbolValues {
    [symbolName: string]: { [numSymbols: number]: number };
}

export interface IFeatureInfo {
    originReelId: number;
    originSymId: number;
}

export interface IS1FeatureInfo extends IFeatureInfo {
    featureName: string;
}

export interface IBetWayWinData {
    length: number;
    amount: number;
    reelWinPositions: boolean[][];
    numberOfCombinations: number;
    multiplier: number;
    multipliedAmount: number;
    mode: string;
    symbol: string;
}

export interface INormalWinConfig {
    duration: number;
    name: string;
}

export interface IBigWinLevel extends INormalWinConfig {
    from: number;
    to: number;
    id: number;
}

interface IInitNextPlayerInteraction {
    featureName: string;
}

export interface IKMDData {
    accumulatedRoundWin: number;
    freespinsLeft: number;
    mode: string;
    nextMode: string;
    reels: string[][];
    specialReels: string[];
    multiplier: number[][];
    finalNudgeMultiplier: number[]; // used in BO only
    stickyNudgeMultiplier: number[];
    playedCapMode: string;
    wasFeatureBuy: boolean;
}

export interface IKMDInitData extends IKMDData {
    symbolValues: ISymbolValues;
    isRestoreState: boolean;
    featureBuyTimesBetValue: FeatureBuyTimesBetValue[];
    nextPlayerInteraction: IInitNextPlayerInteraction;
    lockedFeature: number;
}

export interface IKMDGameData extends IKMDData {
    brokeTheBank: boolean;
    betWayWins: IBetWayWinData[];
    specialBetWayWins: IBetWayWinData[];
    evaluatedArea: string[][]; // used only in game history back-office
    mysterySymbolRevealed: string;
    mysterySymbolSize: number;
    playedBetValue: number;
    totalAvalancheRoundWinnings: number;
    xHoleReels: string[][];
    s1TransformList: string[];
    symbolLines: number[];
    s2TransformSym: string;
    sM1M2TransformSym: string;
    finalMultiplier: number;
}